import { SettingsPayrollEmployeeGroupEmployeeFragment } from 'generated/resources/graphql'

export const terminatedEmployee = (employee: SettingsPayrollEmployeeGroupEmployeeFragment) => {
  return employee.terminatedOn && new Date(employee.terminatedOn).getTime() < Date.now()
}
